"use client";
import clsx from "clsx";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { type ReactNode, useState } from "react";
import { BasketIcon, SearchIcon, UserIcon } from "ui/iconsN";
import { isSearchBarVisibleStore } from "./store";

type Props = {
  basket: ReactNode;
};
export const SideMobile = ({ basket }: Props) => {
  const pathname = usePathname();
  const [isBasketOpen, setIsBasketOpen] = useState(false);

  return (
    <div className="flex gap-4 items-center w-24 xl:hidden">
      <Link href="/account/">
        <UserIcon className="text-pr-1" />
      </Link>
      <div className="relative w-4 h-4">
        <BasketIcon className="text-pr-1 cursor-pointer" onClick={() => setIsBasketOpen(!isBasketOpen)} />
        <div
          className={clsx(
            "bg-primary rounded-lg text-white -left-4 p-2 absolute top-7 z-10 w-80",
            "after:absolute after:left-4 after:bottom-full after:border-8 after:border-transparent after:border-b-primary",
            {
              block: isBasketOpen,
              hidden: !isBasketOpen,
            },
          )}
        >
          {basket}
        </div>
      </div>
      {pathname.startsWith("/voyage/") && (
        <div className="cursor-pointer" onClick={() => isSearchBarVisibleStore.set(!isSearchBarVisibleStore.get())}>
          <SearchIcon className="stroke-pr-1" />
        </div>
      )}
    </div>
  );
};
